import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import ComboBox from '../../../Components/ComboBox'
import { Input } from '../../../Components/Input'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import { makeGetRequest, makePostRequest } from '../../../utils/api'
import urls from '../../../utils/urls'
import { currentDate } from '../../../utils/helpers'
import { Box, useMediaQuery, useTheme } from '@mui/material'

export default function CreateOperationForm({ setOperations, account = null, update = null }) {
  const theme = useTheme()
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(false)
  const [accounts, setAccounts] = useState([])
  const [selectedAccount, setSelectedAccount] = useState([])
  const [categories, setCategories] = useState([])
  const {
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Date: currentDate(),
      NumeroCompte: '',
      Montant: '',
      Libelle: '',
      SousCategorie: '',
    },
  })
  const fetchAccounts = async () => {
    const { data, status } = await makeGetRequest(urls.fetchAccounts + '?limit=1000000', {}, true)
    if (status === 200) {
      const filterAccounts = []
      data.forEach((v) => {
        if (account && account === v.id) {
          setSelectedAccount({
            label: `${v.TypeCompte?.TypeCompte} - ${v.Nom?.Nom} - ${v.NumeroCompte}`,
            id: v.id,
          })
          setValue('NumeroCompte', {
            label: `${v.TypeCompte?.TypeCompte} - ${v.Nom?.Nom} - ${v.NumeroCompte}`,
            id: v.id,
          })
        }
        filterAccounts.push({
          label: `${v.TypeCompte?.TypeCompte} - ${v.Nom?.Nom} - ${v.NumeroCompte}`,
          id: v.id,
        })
      })
      setAccounts([...filterAccounts])
    }
  }

  const fetchCategories = async () => {
    const url = urls.fetchCategories + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterCategories = []
      data.forEach((v) => {
        filterCategories.push({ label: `${v.SousCategorie}`, id: v.id })
      })
      setCategories([...filterCategories])
    }
  }
  const handleClickOpen = () => {
    setOpen(true)
    fetchAccounts()
    fetchCategories()
  }

  const handleClose = () => {
    reset()
    setOpen(false)
  }

  const onSubmit = async (data) => {
    if (data.NumeroCompte === null) {
      alert(t('finance.gestionOperations.selectAccount'))
    } else {
      const payload = {
        ...data,
        NumeroCompte: data.NumeroCompte.id,
      }
      if (data.SousCategorie !== '' && payload.SousCategorie !== null) {
        payload.SousCategorie = data.SousCategorie.id
      }
      const response = await makePostRequest(urls.crudDashboardDetailsOperations, payload, {}, true)
      if (response.status === 201) {
        setOperations((operations) => ({
          ...operations,
          results: [...operations.results, response.data],
          count: operations.count + 1,
        }))
        handleClose()
        if (account && update) {
          update()
        }
      }
    }
  }
  return (
    <>
      {isMobile ? (
        <Box onClick={handleClickOpen}>{t('finance.common.add')}</Box>
      ) : (
        <CustomButton onClick={handleClickOpen}>{t('finance.common.add')}</CustomButton>
      )}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>{t('finance.gestionOperations.addOperationsTitle')}</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            {account ? (
              <ComboBox
                handleAutoComplete={(e, j) => setValue('NumeroCompte', j)}
                label={t('finance.gestionOperations.accountName')}
                data={accounts}
                name="NumeroCompte"
                selectedValue={selectedAccount}
                readOnly
              />
            ) : (
              <ComboBox
                handleAutoComplete={(e, j) => setValue('NumeroCompte', j)}
                label={t('finance.gestionOperations.accountName')}
                data={accounts}
                name="NumeroCompte"
              />
            )}

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Date"
              label={t('finance.gestionOperations.date')}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Libelle"
              label={t('finance.gestionOperations.label')}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                type: 'number',
              }}
              rules={{ required: true }}
              name="Montant"
              label={t('finance.gestionOperations.amount')}
            />
            <ComboBox
              handleAutoComplete={(e, j) => setValue('SousCategorie', j)}
              label={t('finance.gestionOperations.subCategory')}
              data={categories}
              name="SousCategorie"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">{t('finance.common.confirm')}</Button>
            <Button onClick={handleClose}>{t('finance.common.cancel')}</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
